import React, { useEffect, useRef, useState } from 'react';
import { Card, Grid, TextField, Typography, FormHelperText, Stack, Badge, CircularProgress, InputAdornment, Button,  FormControl, InputLabel, Select, MenuItem, Icon,IconButton } from '@mui/material';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import { openSnackbar, uploadImage } from '../../redux/slices/common';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/system';
import { createCategory, deleteCategory, updateCategory } from '../../redux/slices/category';
import { useNavigate, useParams } from 'react-router';
import { isEmptyObject } from 'utilities/common';
import { categoryValidations } from '../../validations/category';
import defaultImage from 'assets/images/placeholder-image.png';
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../redux/slices/modalSlice';
import CommonQuillEditor from 'common/editor';
import { grey } from '@mui/material/colors';
import { AccountCircle, RemoveCircle } from '@mui/icons-material';
import { fetchCategories } from '../../redux/slices/common';
import { slugRegex } from 'utilities/common';
import { STILO, HYPERWOLF } from 'utilities/constants';
import { getData } from 'utilities/common';
import AltImageSection from 'layouts/strains/addStrain/component/ImageUpdate';
import AngleRightIcon from 'common/customIcons/angle_right';
import DeleteIcon from 'common/customIcons/delete';

const initialState = {
  categoryName: '',
  status: 'active',
  description: '',
  productInstructions: '',
  categoryImage: '',
  metaTitle: '',
  metaDescription: '',
  bannerHeading:"",
  canonical: '',
  heading: '',
  createdBy: '',
  bottomText: '',
  bannerImage: '',
  faq: [],
  categoryHeading: '',
  categoryMenuName: '',
  categoryType: 'Cannabis',
};
const AddCategoryForm = () => {
  const { user } = useSelector(state => state.auth);
  const [formData, setFormData] = useState({ ...initialState, createdBy: user?.name });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categoryId = '' } = useParams();
  const { singleCategory = {}, loading = false } = useSelector((state => state.category));
  const { isUploading = false } = useSelector((state => state.common));
  const uploadedImageRef = useRef();
  const [errors, setErrors] = useState({});
  const [productSlugData, setProductSlugData] = useState("")
  const [isProductSlug, setIsProductSlugData] = useState(false)
  const adminsMode = getData('adminsMode')
  const isStilo = JSON.parse(adminsMode) === STILO
  const isHyperWolf = JSON.parse(adminsMode) === HYPERWOLF
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const isQuillContentEmpty = (html = "") => {
    const text = html
      .replace(/<(.|\n)*?>/g, "") // remove tags
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  };


  const productImageUploadHandler = async (e, imageType) => {
    if (isUploading) return;
    uploadedImageRef.current = imageType;
    if (e.target.files.length) {
      const file = e.target.files[0];
      const body = new FormData();
      body.append('filePath', file);
      // dispatch(uploadImage(body)).unwrap().then((res => {
      //   setFormData({ ...formData, [imageType]: res.fileUrl });
      //   uploadedImageRef.current = null;
      //   if (isHyperWolf) {
      //     openSeoImageModal(imageType, file, res.fileUrl);
      //     return;
      //   }
      // }));

      dispatch(uploadImage(body))
        .unwrap()
        .then((res) => {
          if (isHyperWolf) {
            openSeoImageModal(imageType, file, res.fileUrl);
          } else {
            setFormData((prev) => ({
              ...prev,
              [imageType]: res.fileUrl,
            }));
          }
          uploadedImageRef.current = null;
        });

    }
  };

  const onSubmit = () => {
    const { isValid, errors } = categoryValidations({ ...formData, isStilo });
    if (!isValid) {
      setErrors(errors);
      return;
    }
    setErrors({});
    let payload = { ...formData,
      faq: formData.faq?.filter(
        (f) => !isQuillContentEmpty(f?.question) || !isQuillContentEmpty(f?.answer)
      ), };
    if (isProductSlug) {
      payload.categorySlug = productSlugData;
    } else {
      delete payload.categorySlug;
    }
    if (!isStilo) {
      delete payload.categoryType;
      delete payload.bannerHeading;
    }
    if (categoryId) {

      delete payload.categorySlugArray;
      delete payload.canonical;


      dispatch(updateCategory({ data: payload, categoryID: categoryId })).unwrap().then((res) => {
        showError(res?.message, 'success');
        dispatch(fetchCategories({ limit: 1000, skip: 0 }));
        navigate('/categories');
      }).catch((err) => {
        showError(err?.message, 'error');
      });
    } else {
      dispatch(createCategory(payload)).unwrap().then((res) => {
        showError(res?.message, 'success');
        dispatch(fetchCategories({ limit: 1000, skip: 0 }));
        navigate('/categories');
      }).catch((err) => {
        showError(err?.message, 'error');
      });
    }
  };

  const handleChangeFAQ = (value, fieldType, idx) => {
    let FAQArray = [...formData?.faq];
    let faqItem = FAQArray?.find(((faq, _idx) => _idx === idx));
    if (faqItem) {
      const faqItemIdx = FAQArray.indexOf(faqItem);
      faqItem = {
        ...faqItem,
        [fieldType]: value
      };
      FAQArray[faqItemIdx] = faqItem;
      setFormData({ ...formData, faq: FAQArray });
    }
  };

  const handleRemoveFAQ = (faQIdx) => {
    let FAQArray = [...formData?.faq];
    FAQArray = FAQArray?.filter(((faq, _idx) => _idx !== faQIdx));
    setFormData({ ...formData, faq: FAQArray });
  };
  const addFAQHandler = () => {
    let newFAQ = [...formData?.faq];
    let faqItem = {
      question: '',
      answer: ''
    };
    newFAQ = [...newFAQ, faqItem];
    setFormData({ ...formData, faq: newFAQ });
  };
  // const addFAQHandler = () => {
  //   const newFAQ = [...formData?.faq];
  //   const faqItem = {
  //     question: '',
  //     answer: ''
  //   };
  //   newFAQ.unshift(faqItem); // Add new FAQ at the top
  //   setFormData({ ...formData, faq: newFAQ });
  // };

  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  const deleteHandler = (categoryId) => {
    dispatch(setModalLoader(true));
    dispatch(deleteCategory(categoryId)).unwrap().then((res) => {
      showError(res?.message, 'success');
      dispatch(fetchCategories({ limit: 1000, skip: 0 }));
      dispatch(closeCustomModalDialog());
      navigate('/categories');
    }).catch((err) => {
      dispatch(setModalLoader(false));
      showError(err?.message, 'error');
    });
  };

  useEffect(() => {
    if (!isEmptyObject(singleCategory)) {
      if (singleCategory?.categorySlug) {
        setProductSlugData(singleCategory?.categorySlug);
      }
      setFormData({ ...formData, ...singleCategory });
    }
  }, [singleCategory]);

  const uploadThumbnailImage = {
    borderRadius: '20px',
    width: '160px',
    height: '160px',
    objectFit: 'cover',
    boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
  };
  const badgeCircularProgressIcon = {
    backgroundColor: '#fff',
    borderRadius: 10,
    p: .5,
    mr: 14,
    mt: 14
  };

  useEffect(() => {
    setFormData({ ...formData, createdBy: user?.name });
  }, [user]);
  const handleChangeSlug = (e) => {
    const value = e.target.value;
    setIsProductSlugData(true);
    setProductSlugData(slugRegex(value));
  };

  const handleToggle = (e) => {
    setFormData({
      ...formData,
      categoryType: e.target?.checked ? 'Cannabis' : 'Non-Cannabis'
    });
  }
  const getImageSrc = (image) => {
    if (!image) return defaultImage;
    if (typeof image === "string") return image;
    if (typeof image === "object" && image.url) return image.url;
    return defaultImage;
  };

  const openSeoImageModal = (fieldName, file, imageUrl) => {
    const data = {
      url: imageUrl,
      title: file.name,
      alt: "",
      description: "",
    };

    dispatch(
      openCustomModalDialog({
        modal: "IMAGE_MODAL_SEO",
        modalData: {
          imageContent: fieldName,
          data,
          fileMediaHandler: (mediaData, imageContent) => {
            setFormData((prev) => ({
              ...prev,
              [imageContent]: mediaData,
            }));
          },
        },
      })
    );
  };
  const hasImage = isHyperWolf
    ? !!(
      (typeof formData?.categoryImage?.url === "string" &&
        formData.categoryImage.url.trim()) ||
      (typeof formData?.categoryImage === "string" &&
        formData.categoryImage.trim())
    )
    : !!formData?.categoryImage;

  const hasBannerImage = isHyperWolf
    ? !!(
      (typeof formData?.bannerImage?.url === "string" &&
        formData.bannerImage.url.trim()) ||
      (typeof formData?.bannerImage === "string" &&
        formData.bannerImage.trim())
    )
    : !!formData?.bannerImage;


  return (
    <Box p={{ xs: 2, sm: 3, lg: 4 }}>
      <Card sx={{ p: { xs: 2, md: 3 }, mb: 4, borderRadius: 2.5, boxShadow: 'none' }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent='space-between' gap={2} mb={4.5}>

          <span style={{ display: "flex", alignItems: "center" }}  >
            <span style={{ cursor: 'pointer', display: "flex", alignItems: "center", marginRight: "10px" }} onClick={() => { navigate(-1) }}>
              <AngleRightIcon fontSize="14px" />
            </span>
            {isStilo ?
              <Typography variant='h6' fontWeight='semibold'>{categoryId ? `Update Sub Category: ${singleCategory?.categoryName}` : 'Add New Sub Category'} </Typography>
              :
              <Typography variant='h4' fontWeight='semibold' color='secondary'>{!categoryId ? 'Add' : 'Update'} Sub Category</Typography>

            }
          </span>

          <Box display='flex' alignItems='center' gap={1.25}>
            <Typography variant='h5' fontWeight='semibold' color='secondary'>Status</Typography>
            <Stack direction='row' alignItems='center' gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor='#F2F3F7'>
              <MDButton
                sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                type='button'
                variant={formData?.status === 'active' ? 'contained' : 'text'}
                color={formData?.status === 'active' ? 'success' : 'dark'}
                size='small'
                onClick={() => setFormData({ ...formData, status: 'active' })}
              >
                Active
              </MDButton>
              <MDButton
                sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                type='button'
                variant={formData?.status !== 'active' ? 'contained' : 'text'}
                color={formData?.status !== 'active' ? 'error' : 'dark'}
                size='small'
                onClick={() => setFormData({ ...formData, status: 'inactive' })}
              >
                Inactive
              </MDButton>
            </Stack>
          </Box>
        </Stack>
        {!isStilo ?
          <>
            <Typography variant='h5' fontWeight='semibold' mb={2}>Category Image*</Typography>
            <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} mb={4.5}>
              <Badge
                overlap='circular'
                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                badgeContent={
                  isUploading && uploadedImageRef.current === 'categoryImage' ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                }
              >
                <img style={uploadThumbnailImage}
                  // src={isHyperWolf ? formData?.categoryImage?.url || defaultImage :formData?.categoryImage || defaultImage} 
                  src={getImageSrc(formData.categoryImage)}
                  alt='documentId'
                  onClick={() => {
                    if (!isHyperWolf || !formData?.categoryImage?.url) return;
                    dispatch(
                      openCustomModalDialog({
                        modal: "IMAGE_MODAL_SEO",
                        modalData: {
                          imageContent: "image",
                          data: formData.categoryImage,
                          fileMediaHandler: (mediaData) => {
                            setFormData((prev) => ({ ...prev, categoryImage: mediaData }));
                          },
                        },
                      })
                    );
                  }}

                />
              </Badge>
              <label htmlFor='categoryImage-input'>
                <MDButton
                  sx={{ minWidth: '180px' }}
                  type='button'
                  variant='outlined'
                  color='secondary'
                  component='span'
                  disabled={isUploading}
                >
                  {/* {formData?.categoryImage ? 'Change Image' : 'Add Image'} */}
                  {hasImage ? 'Change Image' : 'Add Image'}
                </MDButton>
              </label>
              <MDInput
                id='categoryImage-input'
                type='file'
                name='categoryImage'
                onChange={(e) => productImageUploadHandler(e, 'categoryImage')}
                fullWidth
                disabled={isUploading}
                style={{ display: 'none' }}
              />
              {Boolean(errors?.categoryImage) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.categoryImage}</FormHelperText>}
            </Stack>
            <Typography variant='h5' fontWeight='semibold' mb={2}>Banner Image (Size: 1392x260)</Typography>
            <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} mb={4.5}>
              <Badge
                overlap='circular'
                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                badgeContent={
                  isUploading && uploadedImageRef.current === 'bannerImage' ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                }
              >
                <img style={uploadThumbnailImage}
                  // src={isHyperWolf ? formData?.bannerImage?.url || defaultImage :formData?.bannerImage || defaultImage}
                  src={getImageSrc(formData.bannerImage)}
                  alt='documentId'
                  onClick={() => {
                    if (!isHyperWolf || !formData?.bannerImage?.url) return;
                    dispatch(
                      openCustomModalDialog({
                        modal: "IMAGE_MODAL_SEO",
                        modalData: {
                          imageContent: "image",
                          data: formData.bannerImage,
                          fileMediaHandler: (mediaData) => {
                            setFormData((prev) => ({ ...prev, bannerImage: mediaData }));
                          },
                        },
                      })
                    );
                  }} />
              </Badge>
              <label htmlFor='bannerImage-input'>
                <MDButton
                  sx={{ minWidth: '180px' }}
                  type='button'
                  variant='outlined'
                  color='secondary'
                  component='span'
                  disabled={isUploading}
                >
                  {/* {formData?.bannerImage ? 'Change Image' : 'Add Image'} */}
                  {hasBannerImage ? 'Change Image' : 'Add Image'}
                </MDButton>
              </label>
              <MDInput
                id='bannerImage-input'
                type='file'
                name='bannerImage'
                onChange={(e) => productImageUploadHandler(e, 'bannerImage')}
                fullWidth
                disabled={isUploading}
                style={{ display: 'none' }}
              />
              {Boolean(errors?.bannerImage) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.bannerImage}</FormHelperText>}
            </Stack>
          </> :
          <AltImageSection errors={errors} formData={formData} setFormData={setFormData} isListingImage={false} fieldName={"bannerImage"} fieldNameMobile={'bannerMobileImage'} isbannerImageMobile={true} ratioDesktop={'(Size: 1680x300)'} />
        }
      </Card>

      <Card sx={{ p: { xs: 2, md: 3 }, mb: 4, borderRadius: 2.5, boxShadow: 'none' }}>
        <Typography variant='h5' fontWeight='semibold' mb={4}>{!isStilo ? 'Category Info' : 'Sub Category Info'}</Typography>
        <Grid container spacing={2.5}>
          {
            isStilo &&
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel sx={{ backgroundColor: "#fff", pr: 1 }}>{!isStilo ? 'Category Type' : 'Sub Category Type'}</InputLabel>
                <Select
                  className="form-select"
                  label="Category Type"
                  name="categoryType"
                  value={formData.categoryType}
                  onChange={(e) => setFormData({ ...formData, categoryType: e.target.value })}
                >
                  <MenuItem key="Non-Cannabis" value="Non-Cannabis">Non - Cannabis</MenuItem>
                  <MenuItem key="Cannabis" value="Cannabis">Cannabis</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          }

          <Grid item xs={12} sm={4}>
            <TextField
              label={!isStilo ? 'Category Name*' : 'Sub Category Name*'}
              value={formData.categoryName}
              fullWidth
              variant='outlined'
              onChange={handleInputChange}
              name='categoryName'
              className='form-input'
              error={Boolean(errors?.categoryName)}
              helperText={errors?.categoryName}
            />
          </Grid>
          {/*  new add */}
          <Grid item xs={12} sm={4}>
            <TextField
              label={!isStilo ? 'Category Menu Name' : 'Filter Panel Name'}

              value={formData.categoryMenuName}
              fullWidth
              variant='outlined'
              onChange={handleInputChange}
              name='categoryMenuName'
              className='form-input'
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label={!isStilo ? 'Category Heading (H1)' : 'Sub Category Heading (H1)'}
              value={formData.categoryHeading}
              fullWidth
              variant='outlined'
              onChange={handleInputChange}
              name='categoryHeading'
              className='form-input'
            />
          </Grid>
          {
            (categoryId || isStilo) && <Grid item xs={12} sm={4}>
              <TextField
                className="form-input"
                fullWidth
                label={!isStilo ? "Category Slug" : "Sub Category Slug"}
                name="categorySlug"
                value={productSlugData}
                onChange={handleChangeSlug}
              />  
            </Grid>
          }
          {isStilo && (
            <Grid item xs={12} sm={4}>
              <TextField
              fullWidth
                label="Banner Heading"
                name="bannerHeading"
                value={formData.bannerHeading}
                onChange={handleInputChange}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant='body2' fontWeight='semibold' color={grey[600]} mb={1}>{isStilo ? "Body Text" : "Description*"}</Typography>
            <CommonQuillEditor
              style={true} height={"300px"}
              value={formData?.description || ''}
              onChange={(value) => setFormData({ ...formData, description: value })}
              allowHeading={isStilo ? false : isHyperWolf ? false :true}
            />
            {Boolean(errors?.description) && <FormHelperText error>{errors?.description}</FormHelperText>}
          </Grid>
         <Grid item xs={12}>
            <Typography variant='body2' fontWeight='semibold' color={grey[600]} mb={1}>Instructions*</Typography>
            <CommonQuillEditor
              value={formData?.productInstructions || ''}
              allowHeading={ false }
              onChange={(value) => setFormData({ ...formData, productInstructions: value })}
            />
          </Grid>
          {!isStilo && 
            <Grid item xs={12}>
              <Typography variant='body2' fontWeight='semibold' color={grey[600]} mb={1}>Bottom Text</Typography>
              <CommonQuillEditor
                allowHeading={false}
                value={formData?.bottomText || ''}
                onChange={(value) => setFormData({ ...formData, bottomText: value })}
              />
              {Boolean(errors?.bottomText) && <FormHelperText error>{errors?.bottomText}</FormHelperText>}
            </Grid>
      
          }
        </Grid>
      </Card>

      <Card sx={{ p: { xs: 2, md: 3 }, mb: 4, borderRadius: 2.5, boxShadow: 'none' }}>
        <Grid container spacing={2.5}>
          <Grid item xs={12}>
            <Box display='flex' justifyContent='space-between' alignItems={'center'}>
              <Typography variant='h5' fontWeight="semibold" mb={2}>FAQ&apos;s</Typography>
              {/* {
                formData?.faq?.length > 0 && <Button
                  sx={{ minWidth: '160px' }}
                  type='button'
                  onClick={addFAQHandler}
                  variant='contained'
                  color='primary'
                >Add More</Button>
              } */}
              
            </Box>
            {
              formData?.faq?.length > 0 ? <>
                {
                  formData?.faq?.map(((faq, idx) => {
                    return <Grid key={idx} item xs={12} sm={12} lg={12} my={2}>
                      <Box width={'100%'} className="faq-sec-rep">
                        <Box display='flex' flexDirection='column' justifyContent='space-between' alignItems={'flex-start'} className="mb-3">
                          <Box width={'100%'} display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                            <Typography variant="body2" fontWeight="semibold" color="#2E2E3A">Question</Typography>
                            <IconButton 
                              onClick={() => handleRemoveFAQ(idx)}
                              style={{ color: "#fd4438" }}
                            >
                              <DeleteIcon width="16px" height="16px" />
                            </IconButton>
                          </Box>
                          <Box width={'100%'}>
                            <CommonQuillEditor
                              allowImage={false}
                               allowHeading={false}
                              value={faq?.question || ''}
                              onChange={(value) => handleChangeFAQ(value, 'question', idx)}
                            />
                          </Box>
                        </Box>
                        <Box display='flex' justifyContent='center' alignItems={'flex-start'}>
                          <Box width={'100%'}>
                            <Typography variant="body2" fontWeight="semibold" color="#2E2E3A" mb={1}>Answer</Typography>
                            <CommonQuillEditor
                              allowImage={false}
                               allowHeading={false}
                              value={faq?.answer || ''}
                              onChange={(value) => handleChangeFAQ(value, 'answer', idx)}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Grid>;
                  }))
                }
              </> : <Grid item xs={12} sm={12} lg={12} mt={3}>
                <Box display='flex' justifyContent='space-between' alignItems={'center'}>
                  <MDButton
                    type='button'
                    color='primary'
                    size='medium'
                    variant='outlined'
                    sx={{ minWidth: '180px' }}
                    onClick={addFAQHandler}
                  >
                    <Icon>add</Icon>&nbsp;Add FAQ
                  </MDButton>
                </Box>
              </Grid>
            }
    
            {
              formData?.faq?.length > 0 && 
              <Grid container>
              <Grid item xs={12} mt={3}>
                <MDButton
                  type='button'
                  color='primary'
                  size='medium'
                  variant='outlined'
                  sx={{ minWidth: '180px' }}
                  onClick={addFAQHandler}
                >
                  <Icon>add</Icon>&nbsp;Add More
                </MDButton>
              </Grid>
            </Grid>
            }
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ p: { xs: 2, md: 3 }, mb: 4, borderRadius: 2.5, boxShadow: 'none' }}>
        <Typography variant='h5' fontWeight="semibold" mb={4}>Meta Properties</Typography>
        <Grid container spacing={2.5}>
          <Grid item xs={12} sm={6} lg={4}>
            <TextField
              label='Meta Title*'
              value={formData.metaTitle}
              fullWidth
              variant='outlined'
              onChange={handleInputChange}
              name='metaTitle'
              error={Boolean(errors?.metaTitle)}
              helperText={errors?.metaTitle}
            />
            <span className='drag_drop'>
              Character Count: {formData?.metaTitle?.length || 0} <span>(Recommended Characters: 60)</span>
            </span>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <TextField
              className='form-input created-by'
              label='Created By'
              value={formData.createdBy}
              fullWidth
              disabled
              variant='outlined'
              onChange={handleInputChange}
              name='createdBy'
              error={Boolean(errors?.createdBy)}
              helperText={errors?.createdBy}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <AccountCircle fontSize='medium' color='secondary' />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label='Meta Description'
              value={formData.metaDescription}
              fullWidth
              multiline
              rows={4}
              variant='outlined'
              onChange={handleInputChange}
              name='metaDescription'
              error={Boolean(errors?.metaDescription)}
              helperText={errors?.metaDescription}
              className='form-input'
            />
            <span className='drag_drop'>
              Character Count: {formData?.metaDescription?.length || 0} <span>(Recommended Characters: 160)</span>
            </span>
          </Grid>
        </Grid>
      </Card>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={4} mb={2}>
        <MDButton
          sx={{ minWidth: '160px' }}
          type='button'
          onClick={onSubmit}
          variant='contained'
          color='primary'
          disabled={loading || isUploading}
          loading={loading || isUploading}
        >
          {categoryId ? 'Update' : 'Save'}
        </MDButton>
        {
          categoryId && <MDButton
            sx={{ minWidth: '140px', backgroundColor: '#fdd5d3', color: '#FD4438' }}
            type='button'
            variant='contained'
            color='error'
            onClick={() => {
              dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: categoryId }, modal: 'DELETE_MODAL' }));
            }}
          >
            Delete
          </MDButton>
        }
        <MDButton
          sx={{ minWidth: '160px' }}
          type='button'
          variant='outlined'
          color='dark'
          onClick={() => navigate('/categories')}
        >
          Cancel
        </MDButton>
      </Stack>
    </Box>
  );
};

export default AddCategoryForm;